import { useContext, useReducer } from 'react'
import CountryContext from './CountryContext'
import { countryReducer } from './countryReducer'
import { countryInitialState } from './countryInitialState'
import { Outlet } from 'react-router-dom'

/**
 * @typedef {Object} CountryState
 * @property {boolean} isCountryenticated - Indicates if the user is countryenticated.
 * @property {string} user - The username or ID of the countryenticated user.
 * @property {string} token - The countryentication token.
 */

/**
 * @typedef {Object} CountryContextValue
 * @property {CountryState} countryState - The current countryentication state.
 * @property {Function} countryDispatch - The dispatch function for countryentication actions.
 */

// Custom hook to use the Country context
/**
 * @returns {CountryContextValue} The countryentication context value.
 */

export const useCountryContext = () => useContext(CountryContext)

export const CountryProvider = () => {
  const [countryState, countryDispatch] = useReducer(
    countryReducer,
    countryInitialState,
  )

  return (
    <CountryContext.Provider value={{ countryState, countryDispatch }}>
      <Outlet />
    </CountryContext.Provider>
  )
}
